import { render, staticRenderFns } from "./MemberInvite.vue?vue&type=template&id=197ff372&scoped=true&"
import script from "./MemberInvite.vue?vue&type=script&lang=js&"
export * from "./MemberInvite.vue?vue&type=script&lang=js&"
import style0 from "./MemberInvite.vue?vue&type=style&index=0&id=197ff372&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "197ff372",
  null
  
)

export default component.exports